<template>
  <o-form-wrapper
    v-model="item"
    :server-errors="_se"
    :v="$v.item"
    :schema="schema"
    :form-state="formState"
  >
    <div class="list-group">
      <a href="#" class="list-group-item list-group-item-action">
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1">{{ relatedPost.title }}</h5>
          <small>{{ formatDate(item.created_date) }}</small>
        </div>
        <p class="mb-1">{{ relatedPost.body }}</p>
        <small>{{ relatedPost.author }}</small>
      </a>
    </div>

    <o-widget-wrapper
      :schema="schema"
      name="author"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        flat
        clearable
        v-model="item.author"
        :items="optionUserItems"
        text-field="username"
        value-field="id"
        :validator="$v.item[schema.fields.author.name]"
        :loading="optionUserWorking"
        name="author"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.author"
        :form-state="formState"
        readonly
      ></o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="body"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-area
        v-model="item.body"
        :form-state="formState"
        name="body"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.body"
      ></o-text-area>
    </o-widget-wrapper>

    <o-date-button
      v-model="item.approved"
      name="approved"
      v-bind="schema.fields.approved"
      :form-state="formState"
      :validators="$v.item"
      :server-errors="_se"
      title="Approve"
    >
    </o-date-button>

    <o-date-button
      v-model="item.rejected"
      name="rejected"
      v-bind="schema.fields.rejected"
      :form-state="formState"
      :validators="$v.item"
      :server-errors="_se"
      title="Reject"
    >
    </o-date-button>
  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
  UseRestModuleMixin,
} from "../../../vue-ocom/mixins";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../vue-ocom/components/forms/fields/OTextField";
import OSelect from "../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime";
import OTextArea from "../../../vue-ocom/components/forms/fields/OTextarea";
import ODateButton from "../../../vue-ocom/components/forms/fields/ODateButton";

// import { default as UserForm } from '../../user/components/ItemForm';
import { default as PostForm } from "../../post/components/ItemForm";
import { DateTime } from "luxon";

export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    UseRestModuleMixin("Post"),
    CreateGroupPermissionMixin("Comment"),
    CreateCodeTableFetchMixin(["User", "Post"]),
  ],
  components: {
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,
    OTextArea,
    ODateButton,

    /* UserForm, */ PostForm,
  },
  props: {
    item: { type: Object, default: () => {} },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
  },
  data: () => ({
    schemaModel: cleanUpModel(schema.Comment, {}),
    postAuthor: null,
    postTitle: null,
    postBody: null,
    createdDate: null,
  }),
  methods: {
    getAuthorName(userId) {
      this.getUserById(userId)
        .then((response) => {
          this.postAuthor = response["username"];
        })
        .catch((error) => {
          // todo
        });
    },
    getRelatedPost() {
      const postId = this.item.post;

      if (postId) {
        this.getPostById(postId)
          .then((response) => {
            // this.postAuthor = response["author"];
            this.postTitle = response["title"];
            this.postBody = response["body"];
            this.createdDate = response["created_date"];
            this.getAuthorName(response["author"]);
          })
          .catch((error) => {
            // todo
          });
      }
    },
    formatDate(paramDate) {
      const date = DateTime.fromISO(paramDate);
      const humanReadable = date.toLocaleString(DateTime.DATETIME_MED);
      return humanReadable;
    },
  },
  computed: {
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
    relatedPost() {
      this.getRelatedPost();
      const post = {
        author: this.postAuthor,
        title: this.postTitle,
        body: this.postBody,
        createdDate: this.createdDate,
      };
      return post;
    },
  },
  watch: {},
};
</script>
